/**
 * Styled Components - Created by david on 08/06/18.
 */
import styled from 'styled-components'
import { GRAY_LIGHTEST } from '../../../theme/colors'
import { TextFormat } from '../../../types/common'

export const Container = styled.div`
  overflow-y: scroll;
  height: 100%;
  padding: 6px 18px 24px 18px;
  font-family: Avenir;
`

export const GroupButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 8px;
  background-color: #302628;
  color: white;
  border: none;
  border-radius: 25px;
  font-size: 14px;
  font-weight: 500;
  margin-block: 38px 30px;
  transition: background-color 0.2s ease;
  &:hover {
    background: white;
    color: #302628;
    outline: 1px solid #302628;
    cursor: pointer;
  }
  img {
    max-width: 24px;
    margin-right: 10px;
  }
`

export const TitleLayer = styled.div`
  flex: 1;
  font-size: 18px;
  background: ${GRAY_LIGHTEST};
  padding: 4px 8px;
  border-radius: 2px;
  margin-right: 8px;
  -webkit-text-stroke-width: ${({ strokeWidth }: TextFormat) => strokeWidth}px;
  -webkit-text-stroke-color: ${({ stroke }: TextFormat) => stroke};
  color: ${({ fill }: TextFormat) => fill};
  font-family: ${({ fontFamily }: TextFormat) => fontFamily};
`

export const LayerList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  #empty {
    margin-top: 20px;
    background: #E8E5E5;
    padding: 13px 52px;
    border-radius: 8px;
    font-size: 16px;
  }
  .grabbable:active {
    transform: translate3d(0px, 0px, 0px);
    cursor: grabbing;
    border-radius: 8px;
    outline: 1px solid #31eaff;
  }
  .placeholders {
    height: 0px;
    background: #f1f9f8;
    border-radius: 8px;
    transition: height .25s;
    box-shadow: inset 0 0 0 1px #27e1fd;
  }
`

export const LayerItemContainer = styled.li`
  display: flex;
  align-items: center;
  background-color: #E8E5E5;
  border-radius: 8px;
  padding: 14px 12px;
  cursor: grab;
  &:active {
    background: #ebebeb;
  }
  .rightBtns, .dragIco {
    display: flex;
    height: 30px;
    margin-left: 14px;
    flex: 0.3;
  }
  .dragIco .anticon {
    transform: rotate(90deg);
    font-size: 30px;
    width: 10px;
    height: 10px;
  }
  .contnt {
    max-height: 43px;
    flex: 1;
    object-fit: contain;
    text-align: left;
    color: #232323;
  }
  .lockIco {
    color: #C91731;
    font-size: 18px;
    margin-right: 24px;
  }
  .rightBtns {
    flex: 0.5;
    align-items: center;
    justify-content: flex-end;
  }
  .moreBtn {
    font-size: 11px;
    display: flex;
    flex-flow: column;
    .anticon {
      font-size: 24px;
      height: 18px;
      margin-top: -2px;
    }
    :hover {
      color: black;
      cursor: pointer;
    }
  }
`

export const icoStyle = {
  width: '18px',
  height: '16px',
  marginRight: '14px',
  verticalAlign: 'sub'
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DesignCenterCustomize/LayersTab/styledComponents.tsx